import { combineEpics, ofType } from "redux-observable";
import { of, from as fromPromise, concat } from "rxjs";
import { replace } from "redux-first-history";
import { switchMap, catchError, mergeMap, mapTo } from "rxjs/operators";
import axios from "axios";
import get from "lodash/get";
import includes from "lodash/includes";

import {
  OAUTH_CONSTANT,
  initSession,
  initSessionFail,
  initSessionSuccess,
} from "./oauth.ducks";

const API_END_POINT = process.env.REACT_APP_API_ENDPOINT;

const saveCredential = (action$) =>
  action$.pipe(
    ofType(OAUTH_CONSTANT.SAVE_CREDENTIAL),
    switchMap(($) => {
      if ($.payload.redirect) {
        return concat(of(replace($.payload.redirect)), of(initSession()));
      }
      return of(initSession());
    })
  );

// COMMENT: Token expired -> clear credential then back to home
const revokeCredential = (action$) =>
  action$.pipe(ofType(OAUTH_CONSTANT.CLEAR_CREDENTIAL), mapTo(replace("/")));

const fetchSession = (action$, state$) =>
  action$.pipe(
    ofType(OAUTH_CONSTANT.INIT_SESSION),
    switchMap(() =>
      fromPromise(axios.get(`${API_END_POINT}/profile`)).pipe(
        // pluck("data"),
        // pluck("info"),
        mergeMap((user) => of(initSessionSuccess())),
        catchError((error) => {
          const error_message = get(error, "response.data.error");
          const noRedirectPath = ["/", "/callback"];
          if (includes(noRedirectPath, state$.value.router.location.pathname)) {
            // ไม่ต้อง replace url
            return of(initSessionFail(error_message));
          }
          return of(initSessionFail(error_message));
          // return concat(of(replace("/")), of(initSessionFail(error_message)));
        })
      )
    )
  );

export default combineEpics(saveCredential, revokeCredential, fetchSession);
